import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuxiliaryDataModule } from '../../../../auxiliary-data.module';
import { FieldHandler } from '../../../auxiliary-data-table/auxiliary-data-table.interface';
import { chooseHandler } from '../../../renderer-utils';
import { AuxDataAccountsTableColumnDirective } from '../auxiliary-data-accounts-table-column.directive';

@Component({
  standalone: true,
  template: `
    <ng-container *ngIf="handler">
      <aux-renderer-selector [handler]="handler"></aux-renderer-selector>
    </ng-container>
  `,
  imports: [CommonModule, AuxiliaryDataModule],
  styles: [],
})
export class CustomFieldColumnComponent extends AuxDataAccountsTableColumnDirective implements OnInit {
  handler: FieldHandler;

  constructor() {
    super();
  }

  ngOnInit(): void {
    const jsonData = this.element?.jsonData ? this.element?.jsonData[this.columnDefinition.id] : '';
    const jsonSchema = this.element?.jsonSchema?.properties
      ? this.element?.jsonSchema?.properties[this.columnDefinition.id]
      : '';
    if (jsonData && jsonSchema) {
      this.handler = chooseHandler(this.columnDefinition.id, jsonSchema, jsonData, false, [], true);
    }
  }
}
